// @flow

import React from 'react';

import './Footer.css';

export const Footer = () => (
  <div className="footer">
    <a className="footer-link"
      href="https://github.com/belenbarbed" target="_blank">
      GitHub
    </a>
    <a className="footer-link"
      href="https://www.linkedin.com/in/belenbarbed/" target="_blank">
      LinkedIn
    </a>
    <a className="footer-link"
      href="/docs/belenbarbed-cv.pdf" target="_blank">
      My CV
    </a>
  </div>
)



// WEBPACK FOOTER //
// ./src/Footer/Footer.js